import React, { useState, useEffect, useRef } from "react";
import {useTranslation} from "@/langs/useTranslation";
import useStyles from "@/styles/groupsStyle";
import {BreadCrumbs} from "@/components/device/BreadCrumbs";
import {Button, Typography} from "@material-ui/core";
import WindowsAppList from "./WindowsAppList";
import YourCapacity from "@/components/fileBrowser/YourCapacity";
import {nubisDriveCapacityAPI} from "@/apis/nubisDriveCapacityAPI";
import localforage from "localforage";
import {transformedFormatBytes} from "@/helpers/formatBytesTransformer";

const AndroidApp = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "Windows应用程序" })} />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "Windows应用程序" })}
        </Typography>
      </div>

      <div className={classes.paperWrapper}>
        <WindowsAppList />
      </div>
    </>
  );
};

export default AndroidApp;
export const AndroidAppTableId = "#uploaded-file-table"
